import { env } from '../../config/env'

export const toAbsoluteUrl = (pathname: string) => env.PUBLIC_URL + pathname

export const getIconChannelUrl = (channel: string) => {
  const channelIconMap: Record<string, string> = {
    shopee: "/media/icons/channel/shopee-icon.png",
    lazada: "/media/icons/channel/lazada.png",
    tiktok: "/media/icons/channel/tiktok.png",
    tokopedia: "/media/icons/channel/tokped-icon.png",
    whatsapp: "/media/icons/channel/whatsapp.png",
    blibli: "/media/icons/channel/blibli-icon.png",
    "7days": "/media/icons/channel/7days.png",
  };
  return channelIconMap[channel] || "/media/icons/channel/7days.png";
}
  


